module.exports = __webpack_public_path__ + "static/05-rowan-cake-zoom-c086f3540b7a93f14883bb62a91421ea.jpg";